"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Archive;

var _react = _interopRequireDefault(require("react"));

var _SvgIconWrap = _interopRequireDefault(require("../../../components/SvgIcon/SvgIconWrap"));

function Archive(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIconWrap.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.22222222,22 L4.22222222,2 L11.6296296,2 L11.6296296,3.48148148 L10.1481481,3.48148148 L10.1481481,4.96296296 L11.6296296,4.96296296 L11.6296296,6.44444444 L10.1481481,6.44444444 L10.1481481,7.92592593 L11.6296296,7.92592593 L11.6296296,9.40740741 L10.1481481,9.40740741 L10.1481481,10.8888889 L11.6296296,10.8888889 L11.6296296,12.3703704 L13.1111111,12.3703704 L13.1111111,10.8888889 L11.6296296,10.8888889 L11.6296296,9.40740741 L13.1111111,9.40740741 L13.1111111,7.92592593 L11.6296296,7.92592593 L11.6296296,6.44444444 L13.1111111,6.44444444 L13.1111111,4.96296296 L11.6296296,4.96296296 L11.6296296,3.48148148 L13.1111111,3.48148148 L13.1111111,2 L15.3266667,2 L15.3266667,6.45111111 L19.7777778,6.45111111 L19.7777778,22 L4.22222222,22 Z M13.1111111,13.1111111 L10.1481481,13.1111111 L10.1481481,18.2962963 L13.1111111,18.2962963 L13.1111111,13.1111111 Z M12.3703704,17.5096296 L10.8888889,17.5096296 L10.8888889,16.0281481 L12.3703704,16.0281481 L12.3703704,17.5096296 Z M16.0740741,2 L16.2555556,2 L19.7777778,5.52222222 L19.7777778,5.65777778 L16.0740741,5.65777778 L16.0740741,2 Z"
  }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Upload/icons/Archive.js
// module id = 2004
// module chunks = 6 7 17 18